var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPositionDefense(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.055,
    height: 67.183,
    viewBox: "0 0 43.055 67.183",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_635",
    "data-name": "Grupo 635",
    transform: "translate(709 -2275.994)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "OFENSIVO",
    width: 43,
    height: 21,
    transform: "translate(-709 2277.366)",
    fill: "#79bd4c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_122",
    "data-name": "Ret\\xE2ngulo 122",
    width: 41.948,
    height: 63.058,
    transform: "translate(-708.393 2278.055)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_124",
    "data-name": "Ret\\xE2ngulo 124",
    width: 29.933,
    height: 13.002,
    transform: "translate(-702.386 2278.055)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_125",
    "data-name": "Ret\\xE2ngulo 125",
    width: 13.273,
    height: 5.285,
    transform: "translate(-694.056 2278.055)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_126",
    "data-name": "Ret\\xE2ngulo 126",
    width: 4.794,
    height: 1.561,
    transform: "translate(-689.816 2276.494)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1507",
    "data-name": "Caminho 1507",
    d: "M46.713,45.7a8.111,8.111,0,0,0,12.143,0Z",
    transform: "translate(-740.204 2245.362)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_127",
    "data-name": "Ret\\xE2ngulo 127",
    width: 29.933,
    height: 13.002,
    transform: "translate(-702.386 2328.113)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_128",
    "data-name": "Ret\\xE2ngulo 128",
    width: 13.273,
    height: 5.285,
    transform: "translate(-694.056 2335.83)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_129",
    "data-name": "Ret\\xE2ngulo 129",
    width: 4.794,
    height: 1.561,
    transform: "translate(-689.816 2341.115)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1509",
    "data-name": "Caminho 1509",
    d: "M58.856,151.807a8.111,8.111,0,0,0-12.143,0Z",
    transform: "translate(-740.204 2176.306)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_3",
    "data-name": "Linha 3",
    x2: 41.948,
    transform: "translate(-708.393 2309.584)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_4",
    "data-name": "Elipse 4",
    cx: 6.412,
    cy: 6.426,
    rx: 6.412,
    ry: 6.426,
    transform: "translate(-693.831 2303.158)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_133",
    "data-name": "Ret\\xE2ngulo 133",
    width: 29.933,
    height: 13.002,
    transform: "translate(-702.386 2278.055)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_134",
    "data-name": "Ret\\xE2ngulo 134",
    width: 13.273,
    height: 5.285,
    transform: "translate(-694.056 2278.055)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_135",
    "data-name": "Ret\\xE2ngulo 135",
    width: 4.794,
    height: 1.561,
    transform: "translate(-689.816 2276.494)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1512",
    "data-name": "Caminho 1512",
    d: "M46.713,45.7a8.111,8.111,0,0,0,12.143,0Z",
    transform: "translate(-740.204 2245.362)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_136",
    "data-name": "Ret\\xE2ngulo 136",
    width: 29.933,
    height: 13.002,
    transform: "translate(-702.386 2328.113)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_137",
    "data-name": "Ret\\xE2ngulo 137",
    width: 13.273,
    height: 5.285,
    transform: "translate(-694.056 2335.83)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_138",
    "data-name": "Ret\\xE2ngulo 138",
    width: 4.794,
    height: 1.561,
    transform: "translate(-689.816 2341.115)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1514",
    "data-name": "Caminho 1514",
    d: "M58.856,151.807a8.111,8.111,0,0,0-12.143,0Z",
    transform: "translate(-740.204 2176.306)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1515",
    "data-name": "Caminho 1515",
    d: "M61.65,167.542a1.112,1.112,0,1,1,1.112,1.115,1.113,1.113,0,0,1-1.112-1.115",
    transform: "translate(-750.181 2164.714)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_4",
    "data-name": "Linha 4",
    x2: 41.948,
    transform: "translate(-708.393 2309.584)",
    fill: "#e7e6dd",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1522",
    "data-name": "Caminho 1522",
    d: "M55.756,82.144,51.161,93.05l4.595-1.718L60.35,93.05Z",
    transform: "translate(-743.175 2221.015)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1523",
    "data-name": "Caminho 1523",
    d: "M63.874,30.972a1.112,1.112,0,1,1-1.112-1.115,1.113,1.113,0,0,1,1.112,1.115",
    transform: "translate(-750.181 2255.942)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionDefense);
export default __webpack_public_path__ + "static/media/position-defense.41acc68b92d19c8f7f3ea4227fb0cf67.svg";
export { ForwardRef as ReactComponent };